import { createI18n } from "vue-i18n";
import ko from "./locales/ko.json";
import en from "./locales/en.json";

export const i18n = createI18n({
  legacy: false,          // Composition API 사용
  locale: "en",           // 기본 언어
  fallbackLocale: "en",   // 대체 언어
  messages: { ko, en }
});